import { useEffect } from "react";

/**
 * Hidden partner-rates page.
 * - NOT linked from Navbar or Footer.
 * - Reachable by direct URL only.
 * - Injects <meta name="robots" content="noindex, nofollow"> while mounted.
 */
export default function Partners() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = "Sebastian Visual Corp. — Partner Rates";

    // Inject noindex meta
    let meta = document.querySelector('meta[name="robots"]');
    const created = !meta;
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "robots");
      document.head.appendChild(meta);
    }
    const prevContent = meta.getAttribute("content");
    meta.setAttribute("content", "noindex, nofollow");

    return () => {
      document.title = prevTitle;
      if (created) {
        meta.parentNode && meta.parentNode.removeChild(meta);
      } else if (prevContent !== null) {
        meta.setAttribute("content", prevContent);
      }
    };
  }, []);

  const rates = [
    ["First Hour", "$250 + GST"],
    ["Additional Hourly", "$100 / hr + GST"],
    ["Half-Day", "$500 + GST"],
    ["Full-Day", "$800 + GST"],
  ];

  return (
    <main className="pt-24 md:pt-28 min-h-screen" data-testid="page-partners">
      <section className="max-w-[1100px] mx-auto px-6 md:px-12">
        <div className="h-eyebrow mb-6">§ Partners</div>
        <h1 className="h-display text-4xl md:text-6xl leading-[0.95] max-w-4xl">
          Sebastian Visual Corp.<br/>
          <span className="italic font-serif-editorial text-[var(--gold)] font-light">— Partner Rates.</span>
        </h1>
        <p className="font-serif-editorial italic text-lg md:text-xl text-[var(--ink)]/80 mt-6 max-w-2xl">
          Rates for production partners and fellow shooters with ongoing work. Not public pricing.
        </p>
      </section>

      <section className="max-w-[1100px] mx-auto px-6 md:px-12 mt-14 md:mt-16">
        <div className="border-t border-white/5 pt-8 md:pt-10">
          <div className="h-eyebrow mb-6">§ Rates (+ GST)</div>
          <ul className="divide-y divide-white/5" data-testid="partner-rates">
            {rates.map(([k, v]) => (
              <li key={k} className="flex items-baseline justify-between py-4">
                <span className="font-serif-editorial text-lg md:text-xl text-[var(--ink)]/85">{k}</span>
                <span className="font-sans-display uppercase tracking-[0.18em] text-sm text-[var(--gold)]">{v}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="max-w-[1100px] mx-auto px-6 md:px-12 mt-14 md:mt-16">
        <div className="border-t border-white/5 pt-8 md:pt-10">
          <div className="h-eyebrow mb-6">§ Services</div>
          <p className="font-serif-editorial text-lg md:text-xl leading-relaxed text-[var(--ink)]/85" data-testid="partner-services">
            Stills photography · Video camera operation · FPV and conventional drone (photo + video) · Photo editing (Lightroom / Photoshop) · Video editing (DaVinci Resolve)
          </p>
        </div>
      </section>

      <section className="max-w-[1100px] mx-auto px-6 md:px-12 mt-14 md:mt-16">
        <div className="border-t border-white/5 pt-8 md:pt-10">
          <div className="h-eyebrow mb-6">§ Contact</div>
          <ul className="font-serif-editorial text-lg md:text-xl leading-relaxed text-[var(--ink)]/85 space-y-2" data-testid="partner-contact">
            <li><a className="text-[var(--royal)] hover:underline" href="mailto:ian@sebastianvisualcorp.ca">ian@sebastianvisualcorp.ca</a></li>
            <li><a className="text-[var(--royal)] hover:underline" href="tel:+16049613138">604-961-3138</a></li>
          </ul>
        </div>
      </section>

      <div className="h-20 md:h-24" />
    </main>
  );
}
